"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../typography");
var _constants = require("../../utils/constants");
var _error = _interopRequireDefault(require("../../icons/error"));
var _compact_row = require("../../layouts/compact_row");
var _index = require("./index");
var _theme = _interopRequireDefault(require("./theme"));
var _grid = require("../../layouts/grid");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CONFIRMATION_MODAL_MAX_WIDTH = '400px';
var ConfirmationModal = function ConfirmationModal(props) {
  var isOpen = props.isOpen,
    onDismiss = props.onDismiss,
    ariaLabel = props.ariaLabel,
    children = props.children;
  return /*#__PURE__*/React.createElement(_index.ThemeableModal, (0, _extends2["default"])({
    isOpen: isOpen,
    onDismiss: onDismiss,
    ariaLabel: ariaLabel,
    maxWidth: CONFIRMATION_MODAL_MAX_WIDTH
  }, (0, _constants.getDataProvidesProps)(props)), children);
};
var GridWithFlex = (0, _styledComponents["default"])(_grid.Grid).withConfig({
  displayName: "confirmation_modal__GridWithFlex"
})(["flex:", ";"], function (_ref) {
  var flex = _ref.flex;
  return flex;
});
var ConfirmationModalHeader = function ConfirmationModalHeader(props) {
  var destructive = props.destructive,
    children = props.children;
  return /*#__PURE__*/React.createElement(_index.ThemeableModal.Header, null, /*#__PURE__*/React.createElement(_typography.SectionHeader, null, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, destructive && /*#__PURE__*/React.createElement(GridWithFlex, {
    item: true,
    flex: 0
  }, /*#__PURE__*/React.createElement(_error["default"], {
    size: "sm",
    color: _theme["default"].warning.iconColor
  })), /*#__PURE__*/React.createElement(GridWithFlex, {
    item: true,
    flex: 1
  }, children))));
};
ConfirmationModalHeader.displayName = 'ConfirmationModal.Header';
ConfirmationModal.Header = ConfirmationModalHeader;
ConfirmationModal.Body = _index.ThemeableModal.Body;
ConfirmationModal.Body.displayName = 'ConfirmationModal.Body';
var ConfirmationModalFooter = function ConfirmationModalFooter(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(_index.ThemeableModal.Footer, null, /*#__PURE__*/React.createElement(_compact_row.CompactRow, {
    justifyContent: 'flex-end',
    spacing: 2
  }, children));
};
ConfirmationModalFooter.displayName = 'ConfirmationModal.Footer';
ConfirmationModal.Footer = ConfirmationModalFooter;
var _default = exports["default"] = ConfirmationModal;